import { IDropdownItem } from '@/editor/types';
import { ENodeType, EMoveDirection, ENodeAlign, ETextType } from '@/editor/types/enums';

export const addNodeItems: IDropdownItem[] = [
  {
    icon: 'editor-text-icon',
    text: 'text',
    type: ENodeType.Text,
  },
  {
    icon: 'editor-image-icon',
    text: 'image',
    type: ENodeType.Image,
  },
  {
    icon: 'editor-table-icon',
    text: 'table',
    type: ENodeType.Table,
  },
  {
    icon: 'editor-divider-icon',
    text: 'divider',
    type: ENodeType.Divider,
  },
];

export const textTypeItems: IDropdownItem[] = [
  {
    text: 'normal-text',
    itemClass: 'paragraph',
    type: ETextType.Paragraph,
  },
  {
    text: 'heading-1',
    itemClass: 'heading1',
    type: ETextType.Heading1,
  },
  {
    text: 'heading-2',
    itemClass: 'heading2',
    type: ETextType.Heading2,
  },
  {
    text: 'subheading',
    itemClass: 'subheading',
    type: ETextType.Subheading,
  },
  {
    text: 'small-text',
    itemClass: 'label',
    type: ETextType.Label,
  },
];

export const textAlignItems: IDropdownItem[] = [
  {
    icon: 'editor-align-left',
    text: 'align-left',
    tooltip: 'align-left',
    type: ENodeAlign.Left,
  },
  {
    icon: 'editor-align-center',
    text: 'align-center',
    tooltip: 'align-center',
    type: ENodeAlign.Center,
  },
  {
    icon: 'editor-align-right',
    text: 'align-right',
    tooltip: 'align-right',
    type: ENodeAlign.Right,
  },
  {
    icon: 'editor-align-justify',
    text: 'align-justify',
    tooltip: 'align-justify',
    type: ENodeAlign.Justify,
  },
];

export const moveItems: IDropdownItem[] = [
  {
    icon: 'editor-move-to-top',
    text: 'move-to-top',
    type: EMoveDirection.ToTop,
  },
  {
    icon: 'editor-move-up',
    text: 'move-up',
    type: EMoveDirection.Up,
  },
  {
    icon: 'editor-move-down',
    text: 'move-down',
    type: EMoveDirection.Down,
  },
  {
    icon: 'editor-move-to-bottom',
    text: 'move-to-bottom',
    type: EMoveDirection.ToBottom,
  },
];
